import { CrossSell } from '~/generated/graphql'

export const isComplimentaryCrossSell = (crossSell: Pick<CrossSell, 'festivalDrink'>) => crossSell.festivalDrink
